import React from 'react';
import { 
  FaTooth, 
  FaWrench, 
  FaFlask, 
  FaCut, 
  FaBandAid, 
  FaUserMd, 
  FaBone, 
  FaUser, 
  FaHospital 
} from 'react-icons/fa';
import '../styling/menus.css';

const ProcedureSelection = ({ setStep, setSelectedProcedureType }) => {
  const procedures = [
    {
      id: 'extraction',
      title: 'Tooth Extraction',
      description: 'Simple or surgical tooth extraction',
      Icon: FaTooth,
      iconColor: 'text-teal-600'
    },
    {
      id: 'implant',
      title: 'Dental Implant',
      description: 'Implant placement and restoration',
      Icon: FaWrench,
      iconColor: 'text-teal-600'
    },
    {
      id: 'biopsy',
      title: 'Oral Biopsy',
      description: 'Tissue biopsy and pathology',
      Icon: FaFlask,
      iconColor: 'text-teal-600'
    },
    {
      id: 'cyst',
      title: 'Cyst Removal',
      description: 'Cyst enucleation and treatment',
      Icon: FaCut,
      iconColor: 'text-teal-600'
    },
    {
      id: 'fracture',
      title: 'Fracture Repair',
      description: 'Maxillofacial fracture treatment',
      Icon: FaBandAid,
      iconColor: 'text-teal-600'
    },
    {
      id: 'orthognathic',
      title: 'Orthognathic Surgery',
      description: 'Corrective jaw surgery',
      Icon: FaUserMd,
      iconColor: 'text-teal-600'
    },
    {
      id: 'tmj',
      title: 'TMJ Surgery',
      description: 'Temporomandibular joint treatment',
      Icon: FaBone,
      iconColor: 'text-teal-600'
    },
    {
      id: 'reconstruction',
      title: 'Facial Reconstruction',
      description: 'Reconstructive facial surgery',
      Icon: FaUser,
      iconColor: 'text-teal-600'
    },
    {
      id: 'other',
      title: 'Other Procedure',
      description: 'Other oral/maxillofacial procedure',
      Icon: FaHospital,
      iconColor: 'text-teal-600'
    }
  ];

  const handleProcedureSelect = (procedureId) => {
    // Store selected procedure type
    if (setSelectedProcedureType) {
      setSelectedProcedureType(procedureId);
    }
    // Move to patient ID entry
    setStep('procedurePatientEntry');
  };

  return (
    <div className="menu-screen">
      <h1 className="menu-heading">Select Procedure Type</h1>
      <p className="menu-sub">Choose the oral and maxillofacial surgery procedure you're about to begin</p>
      
      <div className="menu-grid three-cols">
        {procedures.map((procedure) => {
          const IconComponent = procedure.Icon;
          return (
            <div
              key={procedure.id}
              className="menu-card procedure"
              onClick={() => handleProcedureSelect(procedure.id)}
            >
              <div className="menu-icon">
                <IconComponent className={procedure.iconColor} />
              </div>
              <h3 className="menu-title">{procedure.title}</h3>
              <p className="menu-subtitle">{procedure.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProcedureSelection;
